import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App.js";
import "bootstrap/dist/css/bootstrap.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <div className="body">
      <App defaultCity="New York" />
    </div>{" "}
    <p>
      This project was coded by <strong>Yoshino Bollen</strong> and is{" "}
      <a href="https://github.com/yoshino822/weather-app_react_wk5-6">
        open-sourced on GitHub
      </a>{" "}
      and hosted on Netlify
    </p>
  </React.StrictMode>
);
